export const routes = {
  home: '/',
  services: '/services',
  team: '/team',
  contact: '/contact',
  work: '/work',
  notFound: '/not-found',
  blog: '/blog',
  preview: '/preview',
  optOut: '/opt-out',
  optIn: '/opt-in',
};

export const site = {
  title: 'Gridhaus',
  titlePrefix: 'Gridhaus - '
};

export const linkResolver = function (doc) {
  // Pretty URLs for known types
  if (doc.type === 'article') return routes.resources + '/' + doc.uid;
  // Fallback for other types, in case new custom types get created
  return "/doc/" + doc.id;
};


export const ENDPOINT = 'https://gridhaus.cdn.prismic.io/api/v2';





// WEBPACK FOOTER //
// ./src/config.js